export default __webpack_public_path__ + "static/media/menu-04-pricing-b.d5ec7177.svg";